// アプリ初期化ファイルの読み込み（環境設定やPolyfillなど）
import './init';

// Vue 3 の createApp と reactive をインポート
import { createApp, reactive } from 'vue';

// ルートコンポーネントとルーター、共通ミックスインなどの読み込み
import App from './App.vue';
import router from './Routes';
import ApiRouter from './components/Systems/ApiRouter';

// アイコン用コンポーネント（FontAwesome Vue3版）
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

// アンカーリンクスクロール用プラグイン
import VueScrollTo from 'vue-scrollto';

// サードパーティのヘッド管理（VueMetaのVue3対応推奨代替）
import { createHead } from '@vueuse/head'

// Vueアプリケーションを作成
const app = createApp(App);

// 共通ミックスイン登録（全コンポーネントにApiRouterのメソッドやデータを注入）
app.mixin(ApiRouter);

// Vue Router をアプリに登録（ルーティング機能を有効化）
app.use(router);

// FontAwesome のアイコンコンポーネントを 'icon' タグとしてグローバル登録
app.component('icon', FontAwesomeIcon);

// アンカーリンクスクロール機能をプラグインとして使用可能に設定
app.use(VueScrollTo);

// headタグの管理用インスタンス作成と登録
const head = createHead();
app.use(head);

// Vue 3 用のリアクティブなグローバル状態定義
const globalState = reactive({
    searchConditions: {
        keyword: ''
    },
    // 検索結果と状態管理を追加
    searchResult: [],
    searchedKeyword: '',
    searching: false
});

// グローバルプロパティとしてアプリ全体に $globalState で提供
// 全コンポーネントから this.$globalState でアクセス可能
app.config.globalProperties.$globalState = globalState;

// 検索機能をグローバルメソッドとして追加
app.config.globalProperties.searchArticles = function () {
    this.$globalState.searching = true;
    this.$globalState.searchedKeyword = '';
    this.$globalState.searchResult = [];

    window.axios.get(this.routes.articles, {
        params: {
            keyword: this.$globalState.searchConditions.keyword,
            story: true,
        }
    })
        .then((response) => {
            this.$globalState.searchResult = response.data.data;
            this.$globalState.searchedKeyword = this.$globalState.searchConditions.keyword;

            // 検索結果が0件の場合は外部サイトにリダイレクト（mainブランチの仕様を踏襲）
            if (response.data.data.length === 0) {
                window.location.href = 'https://www.japan.travel/en/travel-directory/' + this.$globalState.searchConditions.keyword;
            }
        })
        .finally(() => {
            this.$globalState.searching = false;
        });
};

// 検索条件をリセットするメソッドも追加
app.config.globalProperties.removeAllCondition = function () {
    this.$globalState.searchConditions.keyword = '';
};

// 最後に #app 要素にマウントし、Vueアプリを起動
app.mount('#app');
